module.exports = __webpack_public_path__ + "media/images/stripe/blue-on-dark-7255a4c94d64e7325cb2332a19a8d97c.png";